import { Drawer, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import "./gridControls.scss";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { connect } from "react-redux";
import copyIcon from "../../../../assets/images/copyIcon.svg";

const GridActionItem = ({ key, items, miscState, selectedModel }) => {
  const [showSidePanel, setShowPanel] = useState(false);
  const [isVersionPanel, setIsVersionPanel] = useState(false);
  const toggleDrawer = (open) => (event) => {
    if (
      event?.type === "keydown" &&
      (event?.key === "Tab" || event?.key === "Shift")
    ) {
      return;
    }
    setShowPanel(open);
  };

  useEffect(() => {
    window[`set${selectedModel}Toggle`] = (val) => {
      setIsVersionPanel(false);
      toggleDrawer(true)(null);
    };
    window.showVersionHistory = () => {
      setIsVersionPanel(true);
      setShowPanel(true);
    };
  }, []);

  useEffect(() => {
    if (miscState.selectedClose.isClosed) {
      setShowPanel(false);
    }
  }, [miscState.selectedClose]);

  const handleDrawerClose = (colData) => {
    const { onCloseSidePanel = null } = colData || {};
    if (onCloseSidePanel) {
      onCloseSidePanel();
    } else {
      toggleDrawer(false);
      setShowPanel(false);
    }
  };

  const getActionControls = (col) => {
    switch (col.name) {
      case "edit":
        return (
          <div className="grid-action-item-icon-container" key={"right"}>
            {col?.tab === "drawing" ? (
              <EditIcon
                className="grid-action-item-icon"
                onClick={toggleDrawer(true)}
              />
            ) : (
              <EditIcon
                className="grid-action-item-icon"
                onClick={toggleDrawer(true)}
              />
            )}
            <Drawer
              anchor="right"
              open={showSidePanel}
              onClose={() => {
                handleDrawerClose(col);
              }}
            >
              <div
                style={
                  isVersionPanel
                    ? { width: "500px" }
                    : col.tab === "drawing"
                    ? { width: "1300px" }
                    : { width: col.width ? col.width : "500px" }
                }
              >
                {col?.sidePanelContent}
              </div>
            </Drawer>
          </div>
        );
      case "delete":
        return (
          <div className="grid-action-item-icon-container">
            <DeleteIcon
              className="grid-action-item-icon"
              onClick={col.action}
            />
          </div>
        );
      case "editmsg":
        return (
          <div className="grid-action-item-icon-container">
            <EditIcon
              className="grid-action-item-icon"
              onClick={() => {
                col.action();
              }}
            />
          </div>
        );
      case "copy":
        return (
          <div className="grid-action-item-icon-container">
            <img
              src={copyIcon}
              alt="copy"
              onClick={col.action}
              width={15}
              style={{ cursor: "pointer" }}
              className="grid-action-item-icon"
            />
          </div>
        );
      case "more-options":
        return (
          <div className="grid-action-item-more-icon-container">
            <MoreHorizIcon
              className="grid-action-item-more-icon"
              onClick={col.action}
            />
          </div>
        );
      default:
        break;
    }
  };

  return (
    <Grid
      container
      xs={12}
      key={key}
      spacing={0}
      className="grid-action-container"
    >
      {items.map((i) => {
        return (
          <Grid item md={12 / items.length} className="grid-action-item">
            {getActionControls(i)}
          </Grid>
        );
      })}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  modelState: state.model,
  miscState: state.misc,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(GridActionItem);
